import { BaseLayout, Head } from '@/components/layouts'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import {
  ConsoleOfficialInformationCreateForm,
  ConsoleOfficialInformationCreateValues,
} from './ConsoleOfficialInformationCreateForm'

export * from './fragments'

export type State = {
  artistId: string
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: (values: ConsoleOfficialInformationCreateValues) => Promise<void>
}

export const ConsoleOfficialInformationCreateTemplate: Template<State, Action> =
  ({ state, onSubmit }) => {
    const { t } = useTranslation('consoleOfficialInformationCreate')
    const { routerNames } = useRouter()
    return (
      <ArtistThemeProvider artistId={state.artistId}>
        <Head title={routerNames.ConsoleOfficialInformationCreate} />
        <BaseLayout
          margin
          header={{
            back: true,
            title: t('title'),
          }}
        >
          <ConsoleOfficialInformationCreateForm onSubmit={onSubmit} />
        </BaseLayout>
      </ArtistThemeProvider>
    )
  }
